import React, { useState, useEffect } from "react";
import "./Login.scss";
import { Link} from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { loginUser } from "../services/apiUsers";

function Login() {

    const { login, user } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  
  const [showPassword, setShowPassword] = useState(false);


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Login:", { email, password });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await loginUser({ email, password });
      if (data?.token) {
        login(data.token); // Enregistre dans la session
        navigate("/dashboard"); // Redirige vers la page principale
      } else {
        setError("Identifiants incorrects");
      }
    } catch (err) {
      setError("Erreur de connexion");
    }
  };

  return (
    <div className="login-container">
      <div className="login-bg"></div>      {/* fond animé */}
      <div className="login-overlay"></div> {/* filtre noir */}
        <div className="login-logo">
            <img src='./images/logo.png' className='logo' alt='mon-image' />
            YaOfele
        </div><br/>
      <div className="login-content">
        <div>
            <form className="login-form" onSubmit={handleLogin}>
                <h1>Identifiez-vous</h1>

                <div className="form-group">
                <input
                    type="email"
                    placeholder="Email ou numéro de telephone"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                </div>

                <div className="form-group password-group">
                <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <span
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </span>
                </div>
                
                {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
                <button className="btn-login">
                    Se connecter
                </button>

                <div className="login-options">
                <label>
                    <input type="checkbox" /> Remember me
                </label>
                <a href="#">Need help?</a>
                </div>


                <p className="recaptcha">
                This page is protected by Google reCAPTCHA to ensure you're not a bot.
                </p>
            </form>
        </div>
      </div>

    </div>
  );
}

export default Login;
